import axios from 'axios'

const baseURL = process.env.REACT_APP_IS_PROD == 'true' ? process.env.REACT_APP_BASE_URL : process.env.REACT_APP_STAGING_BASE_URL;

export const defaultInstance = axios.create({ baseURL: baseURL });

defaultInstance.interceptors.request.use((req) => req, (err) => Promise.reject(err))
defaultInstance.interceptors.response.use((res) => res, (err) => Promise.reject(err))

export default defaultInstance
